import { render, staticRenderFns } from "./WaitingForServer.vue?vue&type=template&id=f28bfe1a&scoped=true"
import script from "./WaitingForServer.vue?vue&type=script&lang=js"
export * from "./WaitingForServer.vue?vue&type=script&lang=js"
import style0 from "./WaitingForServer.vue?vue&type=style&index=0&id=f28bfe1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f28bfe1a",
  null
  
)

export default component.exports